// src/components/FlowerCard.js
import React from 'react';

function FlowerCard({ flower, onClose }) {
  if (!flower) return null;

  return (
    <div className="flower-card">
      <button onClick={onClose} className="close-button">X</button>
      <h2>{flower.nombreComun}</h2>
      <img
        src={process.env.PUBLIC_URL + flower.imagenUrl}
        alt={flower.nombreComun}
        className="flower-image-card"
      />
      <p><strong>Nombre Científico:</strong> {flower.nombreCientifico}</p>
      <p><strong>Familia:</strong> {flower.familia}</p>
      <p><strong>Origen:</strong> {flower.origen}</p>
      <p><strong>Colores Comunes:</strong> {flower.coloresComunes.join(', ')}</p>
      <div>
        <strong>Datos Curiosos:</strong>
        <ul>
          {flower.datosCuriosos.map((fact, index) => (
            <li key={index}>{fact}</li>
          ))}
        </ul>
      </div>
      <div>
        <strong>Características Clave:</strong>
        <ul>
          {flower.caracteristicasClave.map((keyFact, index) => (
            <li key={index}>{keyFact}</li>
          ))}
        </ul>
      </div>
    </div>
  );
}

export default FlowerCard;